<div class="full-screen-container">
  <router-outlet></router-outlet>
  <div class="row">
    <div class="col-2">
      <lib-widget-fichaje></lib-widget-fichaje>
    </div>
  </div>
</div>
